var _rect, _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradingNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.5424,
    height: 23.258,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.47931C0 2.00546 2.00546 0 4.47932 0H23.063C25.5369 0 27.5424 2.00546 27.5424 4.47931V4.47931H0V4.47931Z",
    fill: "#18C347"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.54593,
    cy: 1.98112,
    rx: 0.659697,
    ry: 0.689125,
    fill: "#305F1A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.93704,
    cy: 1.98112,
    rx: 0.659697,
    ry: 0.689125,
    fill: "#96D36E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.32864,
    cy: 1.98112,
    rx: 0.659697,
    ry: 0.689125,
    fill: "#519F2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M2.88624 7.48472C2.88669 7.15384 2.98108 6.83054 3.15746 6.55571C3.33384 6.28087 3.58429 6.06686 3.87712 5.94074C4.16996 5.81461 4.49202 5.78205 4.80258 5.84716C5.11313 5.91227 5.39823 6.07213 5.62179 6.30652C5.84536 6.54091 5.99736 6.8393 6.05856 7.16394C6.11976 7.48859 6.08742 7.8249 5.96562 8.13033C5.84382 8.43577 5.63803 8.69661 5.3743 8.87986C5.11057 9.06311 4.80073 9.16053 4.48398 9.15981C4.27374 9.15957 4.0656 9.11603 3.87148 9.03169C3.67736 8.94735 3.50106 8.82385 3.35267 8.66828C3.20427 8.5127 3.0867 8.32809 3.00666 8.125C2.92663 7.92191 2.8857 7.70434 2.88624 7.48472V7.48472Z",
    fill: "#18C347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.08873 11.6675C6.08869 11.9984 5.99471 12.3218 5.81867 12.5969C5.64263 12.872 5.39245 13.0864 5.09977 13.2129C4.80709 13.3394 4.48506 13.3724 4.17442 13.3077C3.86378 13.243 3.57849 13.0835 3.35463 12.8494C3.13077 12.6154 2.9784 12.3172 2.9168 11.9926C2.8552 11.668 2.88714 11.3317 3.00857 11.0261C3.12999 10.7205 3.33546 10.4594 3.59898 10.2758C3.86249 10.0922 4.17221 9.99432 4.48897 9.99463C4.69917 9.99472 4.90729 10.0381 5.10146 10.1222C5.29562 10.2063 5.47202 10.3296 5.62058 10.4849C5.76913 10.6403 5.88694 10.8247 5.96726 11.0276C6.04759 11.2305 6.08887 11.4479 6.08873 11.6675V11.6675ZM4.48855 12.506C4.64676 12.5053 4.80123 12.4557 4.93245 12.3634C5.06367 12.271 5.16576 12.1402 5.2258 11.9873C5.28584 11.8344 5.30115 11.6663 5.2698 11.5043C5.23844 11.3423 5.16183 11.1937 5.04964 11.0771C4.93745 10.9606 4.79471 10.8815 4.63946 10.8496C4.48421 10.8178 4.32341 10.8348 4.17739 10.8984C4.03137 10.962 3.90666 11.0694 3.81904 11.207C3.73141 11.3446 3.6848 11.5062 3.68508 11.6715C3.68638 11.8932 3.77159 12.1054 3.92213 12.2618C4.07266 12.4181 4.27628 12.5059 4.48855 12.5059V12.506Z",
    fill: "#18C347"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.8932 6.65552V7.47631H6.89746V6.65552H10.8932Z",
    fill: "#18C347"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.8923 9.98988H6.89941V9.1665H10.8923V9.98988Z",
    fill: "#18C347"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.89209 12.5004C6.89209 12.2376 6.89209 11.9835 6.8925 11.7286C6.8933 11.7119 6.89499 11.6952 6.89757 11.6787H10.8934V12.5004H6.89209Z",
    fill: "#18C347"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.69006 19.3503H5.94922V25.0001H9.69006V19.3503Z",
    fill: "#18C347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.1969 14.6421H10.4561V24.9999H14.1969V14.6421Z",
    fill: "#18C347"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.6592 16.5254H14.9634V25H18.6592V16.5254Z",
    fill: "#18C347"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.0757 10.0283H19.3799V25.0001H23.0757V10.0283Z",
    fill: "#18C347"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.673 12.3352H23.9321V25H27.673V12.3352Z",
    fill: "#18C347"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.9996 15.8193H28.2588V25.0001H31.9996V15.8193Z",
    fill: "#18C347"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingNav);
export default __webpack_public_path__ + "static/media/trading_nav.1a92df97990904c9baf874f990e65703.svg";
export { ForwardRef as ReactComponent };